import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useState} from 'react'
import {NegativeFeedbackButton, PositiveFeedbackButton} from './Buttons'
import {useSubmitGroupsFeedbackMutation} from '../../mutations/use-submit-groups-feedback-mutation'

export type FeedbackType = 'POSITIVE' | 'NEGATIVE'

export type FeedbackOptions = Array<{
  label: string
  value: string
}>

export type FeedbackSubmitHandler = (props: {
  type: FeedbackType
  feedbackChoice?: string[]
  textResponse?: string
}) => void

const Feedback = ({feedbackOptions}: {feedbackOptions?: FeedbackOptions}) => {
  const [typeSubmitted, setTypeSubmitted] = useState<FeedbackType>()

  const {mutate: handleSubmit} = useSubmitGroupsFeedbackMutation()

  const handleClick = (props: {type: FeedbackType; feedbackChoice?: string[]; textResponse?: string}) => {
    setTypeSubmitted(props.type)
    handleSubmit(props)
  }

  return (
    <div className="d-flex gap-1">
      {typeSubmitted !== 'NEGATIVE' && (
        <PositiveFeedbackButton disabled={!!typeSubmitted} onClick={handleClick} feedbackOptions={feedbackOptions} />
      )}
      {typeSubmitted !== 'POSITIVE' && (
        <NegativeFeedbackButton disabled={!!typeSubmitted} onClick={handleClick} feedbackOptions={feedbackOptions} />
      )}
    </div>
  )
}

export const GroupsFeedback = () => (
  <ErrorBoundary fallback={null}>
    <Feedback />
  </ErrorBoundary>
)

try{ Feedback.displayName ||= 'Feedback' } catch {}
try{ GroupsFeedback.displayName ||= 'GroupsFeedback' } catch {}